import React from 'react';
import { Card, Typography, XStack, YStack } from '@usepepper/sprout-kit-ui';
import { useIsMobileBottomNavLayout } from '@/experiences/sales-portal/blocs/hooks/use-is-mobile-bottom-nav-layout';

export interface InsightCardProps {
  actionsElement?: React.ReactNode;
  children: React.ReactNode;
  subtitle?: string;
  title: string;
}

export const InsightCard: React.FC<InsightCardProps> = ({
  actionsElement,
  children,
  subtitle,
  title,
}) => {
  const isPhone = useIsMobileBottomNavLayout();

  return (
    <Card gap="$8">
      <XStack alignItems="flex-start" gap="$8" justifyContent="space-between">
        <YStack flex={1}>
          <Typography
            numberOfLines={isPhone ? 2 : 1}
            size={isPhone ? '$md' : '$sm'}
            variant="heading"
          >
            {title}
          </Typography>
          {subtitle ? (
            <Typography muted numberOfLines={1} size={isPhone ? '$sm' : '$md'}>
              {subtitle}
            </Typography>
          ) : null}
        </YStack>
        {actionsElement}
      </XStack>
      {children}
    </Card>
  );
};
